export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-50/70">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-lg font-bold">
                911
              </span>
              <span className="font-heading text-lg text-background-50">
                吃瓜网
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/50">
              911吃瓜网是全网最全面的黑料汇总平台，
              专注明星网红内幕曝光与负面新闻整合。
              每日更新最新吃瓜内容，覆盖娱乐圈、
              网红圈、商业圈等多领域黑料，
              为吃瓜群众提供第一手猛料资讯。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: '常见问题', href: '#faq' },
                { label: '热门话题', href: '#topics' },
                { label: '黑料榜单', href: '#ranking' },
                { label: '猛料视频', href: '#media' },
                { label: '专题合集', href: '#index' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }}
                  className="text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2.5 text-sm text-background-50/50">
              <span>投稿邮箱：tips@911chigua.com</span>
              <span>商务合作：bd@911chigua.com</span>
              <span>删改申请：legal@911chigua.com</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              更多合作伙伴正在入驻中，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/35 text-center sm:text-left">
            &copy; 2026 911吃瓜网 版权所有 | 本站内容仅供读者参考，不构成任何建议
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/35">
            <span className="cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">用户协议</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}